import React, {useContext, useEffect, useState} from "react";
import parse from 'html-react-parser';
import SignPadForEsigns from "../CommonComponents/SignPadForEsigns";
import {RecordsManagementContext,ViewMangementContext} from "../StatesMangement/InitialiseContext";
import axios from "axios";
import {Elink, SaveEstimateAddendumValues, SaveEstimateTagValues, DeleteEsignUrl,SaveRadioButtonsValue} from "../CommonComponents/Routes";
import {Modal} from "react-bootstrap";
import swal from 'sweetalert';

export default () => {//this component is used to show company notes .
    let PageView = useContext(ViewMangementContext)
    let [EsignFor , setEsignFor ] = useState('')
    let Record = useContext(RecordsManagementContext)
    let CompanyNote = Record.CP_PageDetails.CompanyNote
    const OpenSignaturePad = async (For) => {
        Record.setESignModal(true) //modal will open for esigns when set value true
        setEsignFor(For) // set the id of the esign  in "EsignFor" state
    }

    const SaveTextFieldsValue = (value, For) => { //save text values ,hit goes to the "save_estimate_addendum_values" function in the "client_portal_controller"
        var url = For.includes("portal") ? SaveEstimateTagValues : SaveEstimateAddendumValues
        Record.setSignatureLoad(true)
        axios({
            method: 'post',
            url: url,
            contentType: "application/json",
            params: {
                estimate_key: Elink,
                type: For.replace("portal", ''),
                value: value
            }
        }).then(res => {
            swal("Saved Successfully", {
                icon: "success",
                buttons: false,
                timer:1000
            });
            Record.setSignatureLoad(false)
        })
    }
    const SaveRadioValue = (id,name) => {
        Record.setSignatureLoad(true)
        axios({
            method: 'post',
            url: SaveRadioButtonsValue,
            contentType: "application/json",
            params: {
                estimate_key: Elink,
                content: id,
                content_type: name
            }}).then((response) => {
            let timerInterval
            swal("Saved Successfully", {
                icon: "success",
                buttons: false,
                timer:1000
            });
            Record.setSignatureLoad(false)
        }).catch(() => {
            swal("Failed", {
                icon: "error",
                buttons: false,
                timer:1000
            });
            Record.setSignatureLoad(false)
        })

    }

    const DeleteEsign = (For)  => { //used to delete the esign
        Record.setSignatureLoad(true)
        let cookie = document.cookie.split('employee_id=')[1] //used to fetch the current employee is admin or not .
        axios({
            method: 'post',
            url: DeleteEsignUrl,
            contentType: "application/json",
            params: {
                estimate_key: Elink,
                employee_key: cookie,
                type: For,
            }}).then((response) => { //update the page view
            Record.SetCP_PageDetails({
                ...Record.CP_PageDetails,
                CompanyNote: response.data.CompanyNotes,
                EstimateAndCompanyInfo: {
                    ...Record.CP_PageDetails.EstimateAndCompanyInfo,
                    CompanyText:response.data.CompanyText.CompanyText }
            })
            Record.setSignatureLoad(false)
        })
    }
    let element = document.getElementsByClassName('esign')
    let element2 = document.getElementsByClassName('deleteesign')
    let element3 = document.getElementsByClassName('portal-radio-btn')
    for (let i = 0; i < element.length; i++) {
        if (element[i] != null) {
            element[i].addEventListener('click', function (evt) {
                let target = evt.target.id;
                OpenSignaturePad(target);
            })
        }
    }

    for (let i = 0; i < element2.length; i++) {
        if (element2[i] != null) {
            element2[i].addEventListener('click', function (evt) {
                let target = evt.target.id;
                DeleteEsign(target);
            })
        }
    }
    useEffect(() => {
        for (let i = 0; i < element.length; i++) {
            if (element[i] != null) {
                element[i].addEventListener('click', function (evt) {
                    let target = evt.target.id;
                    OpenSignaturePad(target);
                })
            }
        }

        for (let i = 0; i < element2.length; i++) {
            if (element2[i] != null) {
                element2[i].addEventListener('click', function (evt) {
                    let target = evt.target.id;
                    DeleteEsign(target);
                })
            }
        }

        for (let i = 0; i < element3.length; i++) {
            if (element3[i] != null) {
                element3[i].addEventListener('change', function (evt)  {
                    let targetRadioButtonId = evt.target.id
                    let targetRadioButtonName = evt.target.name
                    SaveRadioValue(targetRadioButtonId,targetRadioButtonName)
                })

            }
        }
        for (let i = 1; i < 21; i++) {//fetched the text fields and checkboxes by there id's and save the values or text
            let element = document.getElementById(`textfield${i}`)
            let portalelement = document.getElementById(`portaltextfield${i}`)
            let textArea = document.getElementById(`textarea${i}`)
            let portaltextArea = document.getElementById(`portaltextarea${i}`)
            let checkBox = document.getElementById(`checkbox${i}`)
            let portalCheckBox = document.getElementById(`portalcheckbox${i}`)

            if (element !== null) {
                element.addEventListener('change', (e)=> { SaveTextFieldsValue(e.target.value, `textfield${i}`) })
            }
            if (portalelement !== null) {
                portalelement.addEventListener('change', (e)=> { SaveTextFieldsValue(e.target.value, `portaltextfield${i}`) })
            }
            if (textArea !== null) {
                textArea.addEventListener('change', (e)=> { SaveTextFieldsValue(e.target.value, `textarea${i}`) })
            }
            if (portaltextArea !== null) {
                portaltextArea.addEventListener('change', (e)=> { SaveTextFieldsValue(e.target.value, `portaltextarea${i}`) })
            }
            if (checkBox !== null) {
                checkBox.addEventListener('change', (e)=> { SaveTextFieldsValue(e.target.checked, `checkbox${i}`) })
            }
            if (portalCheckBox !== null){
                portalCheckBox.addEventListener('change', (e)=> { SaveTextFieldsValue(e.target.checked, `portalcheckbox${i}`) })
            }
        }
    },[])
    const handleModal = () => {
        Record.setESignModal(false) //close esign modal
    }

    return(
        <>
            <div className="row mt-4" style={Record.SignatureLoad ? {
                pointerEvents: "none", opacity: "0.3",zIndex:800
            } : {}}>
            <div className="col-md-12">
                {CompanyNote ?
                <div className="estimate-text-wrap" style={{color:"#a7a7a7" }}>
                    {parse(`${CompanyNote}`)}
                </div> : <></> }
            </div>
        </div>

         <Modal show={Record.ESignModal} onHide={()=>handleModal()} className={
                'sign_estimate_modal'}
                   style={{top: "16%"}}
            >
            <Modal.Header ><h5 style={{color: "#37abdb", fontSize: "15px", fontWeight: 600}}>
            Signature Pad </h5>
            <button onClick={handleModal}
                    style={{color: "red",background: "white",border: "white" , height: "5%"}}>
                <b className = "contactInfoCloseBtn" >X</b></button></Modal.Header>
             <Modal.Body> <SignPadForEsigns For={EsignFor}/></Modal.Body>
        </Modal>
        </>
    )
};